export default "__VITE_ASSET__k1OeNBci__";